import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { FullScreenLoader } from '@/components/common/FullScreenLoader';
import { environment } from '@/config/environment';
import { buildPlatformUrl } from '@/lib/hostWorkspaceBinding';

const ROOT_PATH = '/';

export function RedirectToPlatform() {
  const location = useLocation();
  const hasPlatformUrl = environment.platformUrl.length > 0;

  useEffect(
    function leaveForPlatform() {
      if (!hasPlatformUrl) {
        return;
      }
      window.location.replace(
        buildPlatformUrl(environment.platformUrl, location.pathname + location.search)
      );
    },
    [hasPlatformUrl, location.pathname, location.search]
  );

  if (!hasPlatformUrl) {
    return <Navigate to={ROOT_PATH} replace />;
  }
  return <FullScreenLoader />;
}
